import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Formats a person's full name handling optional last name cleanly.
// Accepts either a person object ({first_name, last_name}) or (first, last) args.
export function formatName(firstOrPerson, last) {
  if (firstOrPerson && typeof firstOrPerson === 'object') {
    return `${firstOrPerson.first_name || ''} ${firstOrPerson.last_name || ''}`.trim();
  }
  return `${firstOrPerson || ''} ${last || ''}`.trim();
}

// Returns initials from a person object or names; supports missing last name.
export function getInitials(firstOrPerson, last) {
  const f = (firstOrPerson && typeof firstOrPerson === 'object') ? firstOrPerson.first_name : firstOrPerson;
  const l = (firstOrPerson && typeof firstOrPerson === 'object') ? firstOrPerson.last_name : last;
  const a = (f || '').trim()[0] || '';
  const b = (l || '').trim()[0] || '';
  return (a + b).toUpperCase();
}
